import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CategoryComponent } from './physical/category/category.component';
import { SubCategoryComponent } from './physical/sub-category/sub-category.component';
import { BrandComponent } from './physical/brand/brand.component';
import { ProductListComponent } from './physical/product-list/product-list.component';
import { AddProductComponent } from './physical/add-product/add-product.component';
import { AddVariantComponent } from './physical/add-variant/add-variant.component';
import { DigitalCategoryComponent } from './digital/digital-category/digital-category.component';
import { DigitalSubCategoryComponent } from './digital/digital-sub-category/digital-sub-category.component';
import { DigitalListComponent } from './digital/digital-list/digital-list.component';
import { DigitalAddComponent } from './digital/digital-add/digital-add.component';
import { ProductDetailComponent } from './physical/product-detail/product-detail.component';
import { CollectionComponent } from './physical/collection/collection.component';
import { TagComponent } from './physical/Tag/tag.component';
import { ColorComponent } from './physical/colors/color.component';
import { SizeComponent } from './physical/size/size.component';



const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'physical/category',
        component: CategoryComponent,
        data: {
          title: "Category",
          breadcrumb: "Category"
        }
      },
      {
        path: 'physical/sub-category',
        component: SubCategoryComponent,
        data: {
          title: "Sub Category",
          breadcrumb: "Sub Category"
        }
      },
      {
        path: 'physical/product-list',
        component: ProductListComponent,
        data: {
          title: "Product List",
          breadcrumb: "Product List"
        }
      },
      {
        path: 'physical/brand',
        component: BrandComponent,
        data: {
          title: "Brand",
          breadcrumb: "Brand"
        }
      },
      {
        path: 'physical/color',
        component: ColorComponent,
        data: {
          title: "Colors",
          breadcrumb: "Color"
        }
      },  
       {
        path: 'physical/size',
        component: SizeComponent,
        data: {
          title: "Size",
          breadcrumb: "Size"
        }
      },
      {
        path: 'physical/collection',
        component: CollectionComponent,
        data: {
          title: "Collection",
          breadcrumb: "Collection"
        }
      },
      {
        path: 'physical/product-detail',
        component: ProductDetailComponent,
        data: {
          title: "Product Detail",
          breadcrumb: "Product Detail"
        }
      },
      {
        path: 'physical/add-product',
        component: AddProductComponent,
        data: {
          title: "Add Products",
          breadcrumb: "Add Product"
        }
      },{
            path: 'physical/add-variant/:id',
            component: AddVariantComponent,
            data: {
              title: "Add Products variant",
              breadcrumb: "Add Variant"
          }
        },
      {
        path: 'physical/add-variant',
        component: AddVariantComponent,
        data: {
          title: "Add Variant",
          breadcrumb: "Add Variant"
        }
      },
      {
        path: 'physical/tag',
        component: TagComponent,
        data: {
          title: "Tag",
          breadcrumb: "Tag"
        }
      },
      {
        path: 'digital/digital-category',
        component: DigitalCategoryComponent,
        data: {
          title: "Category",
          breadcrumb: "Category"
        }
      },
      {
        path: 'digital/digital-sub-category',
        component: DigitalSubCategoryComponent,
        data: {
          title: "Sub Category",
          breadcrumb: "Sub Category"
        }
      },
      {
        path: 'digital/digital-product-list',
        component: DigitalListComponent,
        data: {
          title: "Product List",
          breadcrumb: "Product List"
        }
      },
      {
        path: 'digital/digital-add-product',
        component: DigitalAddComponent,
        data: {
          title: "Add Products",
          breadcrumb: "Add Product"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductsRoutingModule { }
